import {GtaRatesApi, UsersApi} from "@/Stub/V1";
import { BaseApiConfig } from "@/Service/Api/V1/BaseApiConfig";

export const GtaRatesApiClient = new GtaRatesApi(BaseApiConfig);